/**
 * @generated SignedSource<<73e953e185cd710337c6c32eece8d23c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type freeTextFieldComponent_Query$variables = {};
export type freeTextFieldComponent_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"freeTextFieldComponent_viewer">;
  } | null;
};
export type freeTextFieldComponent_Query = {
  variables: freeTextFieldComponent_Query$variables;
  response: freeTextFieldComponent_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "insight_free_text"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"insight_free_text\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "freeTextFieldComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "freeTextFieldComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "freeTextFieldComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d6a110a237dc1532f2aa52cfb9dbe90a",
    "id": null,
    "metadata": {},
    "name": "freeTextFieldComponent_Query",
    "operationKind": "query",
    "text": "query freeTextFieldComponent_Query {\n  viewer {\n    actualPersonId\n    component(name: \"insight_free_text\")\n    ...freeTextFieldComponent_viewer\n    id\n  }\n}\n\nfragment freeTextFieldComponent_viewer on Viewer {\n  id\n}\n"
  }
};
})();

(node as any).hash = "af937d51690c1e5b329e91a8a0d54682";

export default node;
